import { z } from "zod";

// Schemas

export const AddressSchema = z.object({
  type: z.string(),
  street: z.string(),
  street2: z.string(),
  city: z.string(),
  state: z.string(),
  zip: z.string(),
  country: z.string(),
});
